import { LengthUnits } from "./length-units";
import { PowerUnits } from "./power-units";
import { SpeedUnits } from "./speed-units";
import { TorqueUnits } from "./torque-units";
import { WeightUnits } from "./weight-units";

export class UserPreferences {
  powerUnits = PowerUnits.hp;
  torqueUnits = TorqueUnits.ftlb;
  speedUnits = SpeedUnits.mph;
  weightUnits = WeightUnits.lb;
  lengthUnits = LengthUnits.inch;
  mode: string = 'Lite';
}
